import { createRouter, createWebHistory } from 'vue-router'

const NotFound = () => import('@/views/NotFound.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/s-impliquer',
    name: 'involve',
    component: () => import('@/views/Involve.vue'),
  },
  {
    path: '/a-propos',
    name: 'program',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/soutien',
    name: 'support',
    component: () => import('@/views/Support.vue'),
  },
  {
    path: '/boite-a-outils',
    name: 'themes',
    component: () => import('@/views/Theme/Index.vue'),
  },
  {
    path: '/boite-a-outils/:themeSlug/:childThemeSlug?',
    name: 'theme',
    component: () => import('@/views/Theme/Show.vue'),
    props: true,
  },
  {
    path: '/formations',
    name: 'trainings',
    component: () => import('@/views/Training/Index.vue'),
  },
  {
    path: '/formations/:trainingSlug',
    name: 'training',
    component: () => import('@/views/Training/Show.vue'),
    props: true,
  },
  {
    path: '/projets',
    name: 'projects',
    component: () => import('@/views/Project/Index.vue'),
  },
  {
    path: '/projets/:projectSlug',
    name: 'project',
    component: () => import('@/views/Project/Show.vue'),
    props: true,
  },
  {
    path: '/404',
    name: 'not-found',
    component: NotFound,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'catch-all',
    component: NotFound,
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  linkActiveClass: '-active',
  linkExactActiveClass: '-exact-active',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const target = {
        el: to.hash,
        behavior: 'smooth',
      }

      return to.name === from.name
        ? target
        : new Promise((resolve) => setTimeout(() => resolve(target), 700))
    }

    if (savedPosition) {
      return savedPosition
    }

    if (to.name === from.name) {
      return Object.keys(to.query).length || Object.keys(from.query).length
        ? {}
        : { top: 0, behavior: 'smooth' }
    }

    return new Promise((resolve) => setTimeout(() => resolve({ top: 0 }), 300))
  },
})

export default router
